import { useSuspenseQuery } from "@tanstack/react-query"

import { Themeable } from "@/app/types"
import CompanyDao from "@/entities/company/company.dao"

import CompanyPreview from "./CompanyPreview"


interface CompanyPreviewContainerProps extends Themeable {
  id: string
  size?: "small" | "big"
  companyAvatarBackgroundColor?: string
  companyAvatarLetterColor?: string
}

function CompanyPreviewContainer(props: CompanyPreviewContainerProps) {
  const { data: company } = useSuspenseQuery({
    queryFn: () => CompanyDao.find(props.id),
    queryKey: [CompanyDao.name, props.id]
  })

  return <CompanyPreview {...props} {...company} companyAvatarBackgroundColor={props.companyAvatarBackgroundColor} companyAvatarLetterColor={props.companyAvatarLetterColor} />
}

export default CompanyPreviewContainer
